import React, { Component } from "react";
import { connect } from "react-redux";

import { Wrapper, Row, Button, Copy } from "app/NativeComponents/common";
import { PillButton } from "app/NativeComponents/snippets";

import AssignLeadSearch from "./AssignLeadSearch";
import LeadList from "./LeadList";
import {
  getAutocomplete,
  clearAutocomplete,
  updateConversation
} from "app/NativeActions";
class AssignLead extends Component {
  constructor(props) {
    super(props);

    this.state = {
      lead_search: "",
      selected_lead: null
    };

    this.updateLeadSearch = this.updateLeadSearch.bind(this);
    this.selectLead = this.selectLead.bind(this);
  }

  componentWillUnmount() {
    clearInterval(this._search_interval);
    this.props.clearAutocomplete();
  }

  updateLeadSearch(value) {
    this.setState({
      lead_search: value
    });
    this.props.clearAutocomplete();
    if (value.length > 3) {
      clearInterval(this._search_interval);
      this._search_interval = setTimeout(() => {
        this.props.getAutocomplete({
          token: this.props.token,
          type: "leads",
          search: value
        });
      }, 250);
    }
  }

  getProperties(load_type = "load", search) {
    if (
      this.props.list_properties_refreshing !== true &&
      this.props.list_properties_loading !== true
    ) {
      this.props.getListProperties({
        token: this.props.token,
        load_type: load_type,
        sort_by: "date_created_desc",
        begin: this.props.list_properties_begin,
        limit: this.props.list_properties_limit
      });
    }
  }

  selectLead(lead_id) {
    this.setState({
      selected_lead: lead_id === this.state.selected_lead ? null : lead_id
    });
  }

  renderConfirm() {
    if (this.state.selected_lead) {
      return (
        <Wrapper
          style={{
            padding: 20,
            backgroundColor: this.props.colors.card_color,
            borderTopWidth: 1,
            borderTopStyle: "solid",
            borderTopColor: this.props.colors.border_color
          }}
        >
          <Row style={{ justifyContent: "center" }}>
            <PillButton
              primary={true}
              onPress={() => {
                this.props.updateConversation({
                  token: this.props.token,
                  type: "assign_to_lead",
                  conversation_id: this.props.conversation_info.id,
                  lead_id: this.state.selected_lead,
                  onSuccess: () => {
                    this.props.toggleAssignLead(false);
                  }
                });
              }}
            >
              Assign Lead To Conversation
            </PillButton>
          </Row>
          <Row style={{ justifyContent: "center" }}>
            <Button
              style={{ padding: 10 }}
              onPress={() => {
                this.selectLead(null);
              }}
            >
              <Copy>Cancel Selection</Copy>
            </Button>
          </Row>
        </Wrapper>
      );
    }
  }

  render() {
    return (
      <Wrapper
        style={{
          height: "100%",
          backgroundColor: this.props.colors.background_color
        }}
      >
        <AssignLeadSearch
          lead_search={this.state.lead_search}
          updateLeadSearch={this.updateLeadSearch}
        />
        <Wrapper style={{ flex: 1 }}>
          <LeadList
            {...this.props}
            selectLead={this.selectLead}
            getProperties={this.getProperties}
            selected_lead={this.state.selected_lead}
          />
        </Wrapper>
        {this.renderConfirm()}
      </Wrapper>
    );
  }
}

const mapStateToProps = ({ property_map }) => {
  const {
    autocomplete_loading,
    autocomplete_items,
    autocomplete_error
  } = property_map;

  return {
    autocomplete_loading,
    autocomplete_items,
    autocomplete_error
  };
};

export default connect(mapStateToProps, {
  getAutocomplete,
  clearAutocomplete,
  updateConversation
})(AssignLead);
